<template>
  <div class="row">
    <div class="col-12 card card-custom">
      <div class="card-body py-0 border-bottom">
        <ul class="nav nav-tabs nav-tabs-line border-bottom-0" role="tablist">
          <!--
          <li class="nav-item mr-14 mt-4">
            <router-link :to="{ name: '/sunbeds/view/:guid/updates/overview' }" class="nav-link font-weight-bold border-2 pb-6 mx-0" data-toggle="tab" active-class="active">
              <span class="nav-icon">
                <i>
                  <font-awesome-icon :icon="['fas', 'list']" />
                </i>
              </span>
              <span class="nav-text">Overview</span>
            </router-link>
          </li>
          -->

          <li class="nav-item mr-14 mt-4">
            <router-link :to="{ name: '/sunbeds/view/:guid/updates/sunbed' }" class="nav-link font-weight-bold border-2 pb-6 mx-0" data-toggle="tab" active-class="active">
              <span class="nav-icon">
                <i>
                  <font-awesome-icon :icon="['fas', 'tag']" />
                </i>
              </span>
              <span class="nav-text">Sunbed</span>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="card-body">
        <router-view
          ref="router-view"
          :equipment="equipment"
          :device="device"
        />
      </div>
    </div>
  </div>
</template>

<script>
import equipmentMixin from '@/components/pages/sunbeds/view/libs/mixin';

export default {
  mixins: [equipmentMixin],
};
</script>
